import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import VisitorTracker from "@/components/VisitorTracker";
import BackButton from "@/components/BackButton";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Addresses from "@/pages/Addresses";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import StripesApplication from "@/pages/StripesApplication";
import ShippingReturns from "@/pages/ShippingReturns";
import TermsConditions from "@/pages/TermsConditions";
import TermsOfService from "@/pages/TermsOfService";
import CustomsDuty from "@/pages/CustomsDuty";
import UsaDeliveryDuties from "@/pages/UsaDeliveryDuties";
import Orders from "@/pages/Orders";
import CustomSticker from "@/pages/CustomSticker";
import Wishlist from "@/pages/Wishlist";
import MeetMiniStripes from "@/pages/MeetMiniStripes";
import MiniStripesOwnersClub from "@/pages/MiniStripesOwnersClub";
import MyDesign from "@/pages/MyDesign";
import TestHexisColors from "@/pages/TestHexisColors";
import HowToApply from "@/pages/HowToApply";
import NewProducts from "@/pages/NewProducts";
import GraphicsSupplyFitting from "@/pages/GraphicsSupplyFitting";
import VehicleWrapping from "@/pages/VehicleWrapping";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <CurrencyProvider>
          <AuthProvider>
            <CartProvider>
              <WishlistProvider>
                <BrowserRouter>
                  <ScrollToTop />
                  <VisitorTracker />
                  <div className="min-h-screen flex flex-col noise-overlay">
                    <Navbar />
                    <BackButton />
                  <main className="flex-1">
                    <Routes>
                    <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:category" element={<Products />} />
                  <Route path="/new-products" element={<NewProducts />} />
                  <Route path="/shop" element={<Products />} />
                  <Route path="/shop/:category" element={<Products />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/addresses" element={<Addresses />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/stripes-application" element={<StripesApplication />} />
                  <Route path="/shipping-returns" element={<ShippingReturns />} />
                  <Route path="/shipping" element={<ShippingReturns />} />
                  <Route path="/returns" element={<ShippingReturns />} />
                  <Route path="/terms-conditions" element={<TermsConditions />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/customs-duty" element={<CustomsDuty />} />
                  <Route path="/usa-delivery-duties" element={<UsaDeliveryDuties />} />
                  <Route path="/custom-sticker" element={<CustomSticker />} />
                  <Route path="/custom-text-decals" element={<CustomSticker />} />
                  <Route path="/meet-mini-stripes" element={<MeetMiniStripes />} />
                  <Route path="/graphics-supply-fitting" element={<GraphicsSupplyFitting />} />
                  <Route path="/vehicle-wrapping" element={<VehicleWrapping />} />
                  <Route path="/mini-owners-club" element={<MiniStripesOwnersClub />} />
                  <Route path="/forum" element={<MiniStripesOwnersClub initialView="forum" />} />
                  <Route path="/gallery" element={<MiniStripesOwnersClub initialView="gallery" />} />
                  <Route path="/for-sale" element={<MiniStripesOwnersClub initialView="marketplace" />} />
                  <Route path="/my-design" element={<MyDesign />} />
                  <Route path="/test-hexis-colors" element={<TestHexisColors />} />
                  <Route path="/how-to-apply" element={<HowToApply />} />
                  <Route path="/admin/*" element={<Admin />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  </CurrencyProvider>
  </LanguageProvider>
  </HelmetProvider>
  );
}

export default App;
